// Defer rollover (hover) images: fetch them only when a card is hovered or
// focused, so the initial grid loads ~half as many images. Touch devices have
// no rollover, so they never download these images at all.
//
// Lives in its own file (loaded globally from theme.liquid) rather than inside
// collection-filter.js, because `collection-card` renders from several grid
// sections — collection-grid, -smaller, -new-releases, -section — and only
// filterable collection pages pull in the collection-filter section. Anywhere
// else the promoter never ran and the hover images, which ship with data-srcset
// and no src, had nothing to load.
document.querySelectorAll('.js-hover-defer').forEach((img) => {
    const card = img.closest('.js-grid-item') || img;
    const load = () => {
        if (img.dataset.srcset) { img.srcset = img.dataset.srcset; }
        if (img.dataset.src) { img.src = img.dataset.src; }
        card.removeEventListener('mouseenter', load);
        card.removeEventListener('focusin', load);
    };
    card.addEventListener('mouseenter', load);
    card.addEventListener('focusin', load);
});
